import AccountCategoryModel from "./AccountCategoryModel";
import AccountProgressModel from "./AccountProgressModel";
import AccountSubCategoryModel from "./AccountSubCategoryModel";
import {ECompanySize} from '../enum/ECompanySize';
import {EPrimaryRole} from '../enum/EPrimaryRole';
import {EAccountCategory} from '../enum/EAccountCategory';
import Region from './Region';

export default class CreateAccountRequest {

FirstName :string = '';

LastName :string = '';

BusinessName :string = '';

AccountCategory : EAccountCategory = EAccountCategory.NotMentioned;

Email : string = '';

Phone :string = '';

Password :string = '';

ConfirmPW:string = '';

AgreeToTerms :boolean = false;

PrimaryRole : EPrimaryRole = EPrimaryRole.NotMentioned;

CompanySize : ECompanySize = ECompanySize.NotMentioned;

Regions : Region[] = [];

WebSite : string = '';

Description : string = '';

InitialStudioID : number = 0;

IdentityUserId : string = '';

AvailableAccountCategories : Array<AccountCategoryModel> = [];

AccountSubCategories : string[] = [];

OtherSubAccountCategories: string = '';

AccountSubCategoryId: number = 0;
 
AccountProgress : AccountProgressModel = {
    Step: 0
};

}